import {ColumnGroup} from 'notebook/structured-tables/columns/ColumnDefinitions';
import {StructuredTableColumn} from 'notebook/structured-tables/StructuredTableConstants';
import {TableColumnType} from 'notebook/tables/constants/TableColumnConstants';

export default function filterOutColumnTypes(
  columns: Array<StructuredTableColumn>,
  types: Array<TableColumnType>
): Array<StructuredTableColumn> {
  return columns.filter((column) => !types.includes(column.columnType));
}

export function filterOutColumnTypesWithColumnGroups(
  columns: Array<StructuredTableColumn>,
  types: Array<TableColumnType>,
  columnGroupsForTypes: {[columnType in TableColumnType]?: Array<ColumnGroup | null>}
): Array<StructuredTableColumn> {
  const hasMatchingColumnGroup = (column: StructuredTableColumn): boolean =>
    columnGroupsForTypes[column.columnType] == null ||
    columnGroupsForTypes[column.columnType]!.includes(column.columnGroup ?? null);
  return columns.filter((column) => !(types.includes(column.columnType) && hasMatchingColumnGroup));
}
